import { LoadingState } from '@lcs/shared/api';
import { createFeatureSelector, on } from '@ngrx/store';
import { RegisterState } from 'src/app/common-components/register/models/register-state';
import {
   RegisterAdapter,
   createRegisterAdapter,
} from 'src/app/common-components/register/models/register-state.adapter';
import { DepartmentsFilterOption } from '../models/department-filter-option';
import { DepartmentOrderingOptions, DepartmentRegisterOptions } from '../models/department-register-options';
import { DepartmentRegisterListItem } from '../models/department-register-results.model';
import * as departmentRegisterActions from './department-register.actions';

export const departmentRegisterFeatureKey = 'departmentRegister';

export interface DepartmentRegisterState
   extends RegisterState<DepartmentRegisterListItem, DepartmentRegisterOptions, DepartmentOrderingOptions> {
   filters: DepartmentsFilterOption[];
   departmentNames: string[];
}

const adapter: RegisterAdapter<DepartmentRegisterListItem, DepartmentRegisterOptions, DepartmentOrderingOptions> =
   createRegisterAdapter<DepartmentRegisterListItem, DepartmentRegisterOptions, DepartmentOrderingOptions>({
      selectId: (departmentRegisterItem) => {
         return departmentRegisterItem.departmentId ?? 0;
      },
   });

export const initialState: DepartmentRegisterState = {
   ...adapter.getInitialState(),
   filters: [],
   departmentNames: [],
};

export const departmentRegisterReducer = adapter.createReducer(
   departmentRegisterActions.departmentRegisterAdapterActions,
   initialState,
   on(departmentRegisterActions.departmentRegisterAdapterActions.pageEnter, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),
   on(departmentRegisterActions.departmentRegisterAdapterActions.loadSuccess, (state, action) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
         endCursor: action.endCursor,
         hasNextPage: action.hasNextPage,
         department: action.items,
         totalCount: action.totalCount,
      };
   }),
   on(departmentRegisterActions.departmentRegisterAdapterActions.quickFilterChanged, (state, action) => {
      return {
         ...state,
         callState: LoadingState.Loading,
         quickFilters: {
            ...state.quickFilters,
            ...action.quickFilters,
         },
      };
   }),
   on(departmentRegisterActions.departmentRegisterInitialFilter, (state, action) => {
      return {
         ...state,
         filters: action.filters,
      };
   }),
   on(departmentRegisterActions.departmentRegisterAdapterActions.orderingOptionsChanged, (state, action) => {
      return {
         ...state,
         callState: LoadingState.Loading,
         orderingOptions: action.orderingOptions,
      };
   }),
   on(departmentRegisterActions.loadingUrlParams, (state) => ({
      ...state,
      callState: LoadingState.Loading,
   })),
   on(departmentRegisterActions.loadedUrlParams, (state, action) => ({
      ...state,
      callState: LoadingState.Loaded,
      selectedId: action.departmentId,
   })),
   on(departmentRegisterActions.loadDepartmentNamesSuccess, (state, action) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
         departmentNames: action.departmentNames,
      };
   })
);
export const departmentRegisterSelector = createFeatureSelector<DepartmentRegisterState>(departmentRegisterFeatureKey);
export const selectors = adapter.getSelectors(departmentRegisterSelector);
export const {
   selectAll,
   selectCallState,
   selectTotalCount,
   selectQuickFilters,
   selectEndCursor,
   selectOrderingOptions,
} = adapter.getSelectors(departmentRegisterSelector);
